import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import classNames from "classnames";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { faMagnifyingGlass, faUserCircle, faCircleInfo, faChevronLeft, faChevronRight, faEllipsisVertical, faXmark, faInfoCircle } from "@fortawesome/pro-regular-svg-icons";
import Tooltip from "../Tooltip";
import AwesomeIcon from "../AwesomeIcon";
import { formatFiltersObj } from "../SearchFilters/utils";
import setDefaultFilters from "./services/setDefaultFilters";
import constants from "../../utils/constants";
import DebounceInput from "../common/DebounceInput";
import { trackEvent } from "../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../utils/mixpanelEvents";
import useCheckLCContainer from "../../hooks/useCheckLCContainer";
import { useAuth } from "@qure/qure-auth";
import Toast from "../Toast";
import { applyFilterOrder } from "../../utils/filterOrder";
import { PatientsContext } from "../Patients/PatientsContext";
import { requestWorklistFilterChange } from "../../utils/worklistFilterNavigation";
var LCAccessFilters = function LCAccessFilters(props) {
  var _mainContainerRef$cur, _scrollContainerRef$c;
  var setFilters = props.setFilters,
    filters = props.filters,
    setLastId = props.setLastId,
    setSavedFilterData = props.setSavedFilterData,
    onChangeSearch = props.onChangeSearch,
    isCountLoading = props.isCountLoading,
    patientsCount = props.patientsCount,
    _props$setDefaulToFir = props.setDefaulToFirstFilter,
    setDefaulToFirstFilter = _props$setDefaulToFir === void 0 ? true : _props$setDefaulToFir,
    _props$showSearch = props.showSearch,
    showSearch = _props$showSearch === void 0 ? true : _props$showSearch,
    _props$showOverflowFi = props.showOverflowFiltersOnHover,
    showOverflowFiltersOnHover = _props$showOverflowFi === void 0 ? false : _props$showOverflowFi,
    setPatientsData = props.setPatientsData,
    savedFilters = props.savedFilters;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    canScrollLeft = _useState[0],
    setCanScrollLeft = _useState[1];
  var _useState2 = useState(false),
    canScrollRight = _useState2[0],
    setCanScrollRight = _useState2[1];
  var _useState3 = useState(false),
    showOverflowPopover = _useState3[0],
    setShowOverflowPopover = _useState3[1];
  // State for tracking selected filters in popover (for multi-select)
  var _useState4 = useState([]),
    selectedFiltersInPopover = _useState4[0],
    setSelectedFiltersInPopover = _useState4[1];
  var _useState5 = useState(false),
    isSettingDefaultFilters = _useState5[0],
    setIsSettingDefaultFilters = _useState5[1];
  var scrollContainerRef = useRef(null);
  var filterRefs = useRef(new Map());
  var overflowButtonRef = useRef(null);
  var popoverRef = useRef(null);
  var mainContainerRef = useRef(null);
  // Track if we're programmatically setting selection (to prevent useEffect from overwriting)
  var isSettingSelectionProgrammatically = useRef(false);
  var currentSearch = get(filters, ["data", "search"], "");
  var isLCWorklist = useCheckLCContainer();
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo,
    refetchProfile = _useAuth.refetchProfile;
  var _useContext = useContext(PatientsContext),
    filterOrder = _useContext.filterOrder;
  var checkScrollPosition = useCallback(function () {
    var container = scrollContainerRef.current;
    if (container) {
      var _scrollLeft = container.scrollLeft,
        scrollWidth = container.scrollWidth,
        clientWidth = container.clientWidth;
      setCanScrollLeft(_scrollLeft > 0);
      setCanScrollRight(_scrollLeft + clientWidth < scrollWidth - 1);
    }
  }, []);

  // Apply persisted filter_order as the base sort, then promote selected filters to
  // the front when showOverflowFiltersOnHover is true.
  var orderedFilterList = useMemo(function () {
    var base = applyFilterOrder(savedFilters, filterOrder);
    if (!showOverflowFiltersOnHover) {
      return base;
    }

    // Handle multi-select: show all selected filters first
    if (filters !== null && filters !== void 0 && filters.selectedFilters && Array.isArray(filters.selectedFilters) && filters.selectedFilters.length > 0) {
      var selectedIds = new Set(filters.selectedFilters.map(function (f) {
        return f.id;
      }));
      var selectedFilters = base.filter(function (item) {
        return selectedIds.has(item.id);
      });
      var otherFilters = base.filter(function (item) {
        return !selectedIds.has(item.id);
      });
      return [].concat(_toConsumableArray(selectedFilters), _toConsumableArray(otherFilters));
    }

    // Handle single-select: show selected filter first
    if (filters !== null && filters !== void 0 && filters.id) {
      var selectedFilter = base.find(function (item) {
        return item.id === filters.id;
      });
      var _otherFilters = base.filter(function (item) {
        return item.id !== filters.id;
      });
      return selectedFilter ? [selectedFilter].concat(_toConsumableArray(_otherFilters)) : base;
    }
    return base;
  }, [savedFilters, filters === null || filters === void 0 ? void 0 : filters.id, filters === null || filters === void 0 ? void 0 : filters.selectedFilters, showOverflowFiltersOnHover, filterOrder]);
  useEffect(function () {
    checkScrollPosition();
  }, [checkScrollPosition, savedFilters]);
  var scrollLeft = function scrollLeft() {
    trackEvent(MIXPANEL_EVENTS.LC_FILTER_SCROLL, {
      label: "left"
    });
    var container = scrollContainerRef.current;
    if (container) {
      container.scrollBy({
        left: -300,
        behavior: "smooth"
      });
      // Update state after scroll animation completes
      setTimeout(function () {
        checkScrollPosition();
      }, 300);
    }
  };
  var scrollRight = function scrollRight() {
    trackEvent(MIXPANEL_EVENTS.LC_FILTER_SCROLL, {
      label: "right"
    });
    var container = scrollContainerRef.current;
    if (container) {
      container.scrollBy({
        left: 300,
        behavior: "smooth"
      });
      // Update state after scroll animation completes
      setTimeout(function () {
        checkScrollPosition();
      }, 300);
    }
  };
  var handleOverflowClick = function handleOverflowClick() {
    if (showOverflowPopover) {
      setShowOverflowPopover(false);
    } else {
      setShowOverflowPopover(true);
      trackEvent(MIXPANEL_EVENTS.LC_FILTER_OVERFLOW_OPENED);
      // Initialize selection with currently applied filters when opening popover
      if (filters !== null && filters !== void 0 && filters.selectedFilters && Array.isArray(filters.selectedFilters)) {
        // Multi-select: use selectedFilters directly
        setSelectedFiltersInPopover(filters.selectedFilters);
      } else if (filters !== null && filters !== void 0 && filters.id && filters !== null && filters !== void 0 && filters.isFilterApplied) {
        // Single-select: convert to selectedFiltersInPopover format
        var singleFilter = savedFilters.find(function (item) {
          return item.id === filters.id;
        });
        if (singleFilter) {
          setSelectedFiltersInPopover([{
            id: singleFilter.id,
            values: singleFilter.filter
          }]);
        } else {
          setSelectedFiltersInPopover([]);
        }
      } else {
        // No filters applied: clear selection
        setSelectedFiltersInPopover([]);
      }
    }
  };

  // Close popover when clicking outside
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (showOverflowPopover && popoverRef.current && overflowButtonRef.current && !popoverRef.current.contains(event.target) && !overflowButtonRef.current.contains(event.target)) {
        setShowOverflowPopover(false);
      }
    };
    if (showOverflowPopover) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showOverflowPopover]);

  // Sync selectedFiltersInPopover when filters change (if popover is open), it should happen only when the popover is open
  useEffect(function () {
    if (showOverflowPopover && !isSettingSelectionProgrammatically.current) {
      if (filters !== null && filters !== void 0 && filters.selectedFilters && Array.isArray(filters.selectedFilters)) {
        // Multi-select: use selectedFilters directly
        setSelectedFiltersInPopover(filters.selectedFilters);
      } else if (filters !== null && filters !== void 0 && filters.id && filters !== null && filters !== void 0 && filters.isFilterApplied) {
        // Single-select: convert to selectedFiltersInPopover format
        var singleFilter = savedFilters.find(function (item) {
          return item.id === filters.id;
        });
        if (singleFilter) {
          setSelectedFiltersInPopover([{
            id: singleFilter.id,
            values: singleFilter.filter
          }]);
        } else {
          setSelectedFiltersInPopover([]);
        }
      } else {
        // No filters applied: clear selection
        setSelectedFiltersInPopover([]);
      }
    }
  }, [filters === null || filters === void 0 ? void 0 : filters.id, filters === null || filters === void 0 ? void 0 : filters.selectedFilters, filters === null || filters === void 0 ? void 0 : filters.isFilterApplied, showOverflowPopover]);
  var handleSingleTagchange = function handleSingleTagchange(item) {
    requestWorklistFilterChange(function () {
      var name = item.name,
        filter = item.filter,
        id = item.id;
      var formattedFilters = formatFiltersObj(filter);
      var appliedFilter = {
        isFilterApplied: true,
        label: name,
        data: formattedFilters,
        id: id
      };
      setFilters(appliedFilter);
      setSavedFilterData(filter);
      localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(appliedFilter));
      localStorage.setItem(constants.PERSISTED.savedFilterData, JSON.stringify(filter));
      // Reset explicitly cleared flag when filters are explicitly applied

      trackEvent(MIXPANEL_EVENTS.LC_FILTER_APPLIED, {
        filterName: name,
        isQuickAccessFilter: true
      });
    });
  };

  // Handle toggle selection in popover (for multi-select)
  var handleToggleFilterSelection = function handleToggleFilterSelection(item) {
    setSelectedFiltersInPopover(function (prev) {
      var isSelected = prev.some(function (filter) {
        return filter.id === item.id;
      });
      if (isSelected) {
        // Deselect
        return prev.filter(function (filter) {
          return filter.id !== item.id;
        });
      } else {
        // Select - add with only values property
        return [].concat(_toConsumableArray(prev), [{
          id: item.id,
          values: item.filter
        }]);
      }
    });
  };

  // Handle applying multiple selected filters
  var handleMultipleFiltersApply = function handleMultipleFiltersApply() {
    if (selectedFiltersInPopover.length === 0) {
      setFilters({
        isFilterApplied: false,
        data: {
          search: get(filters, ["data", "search"], "")
        }
      });
      setLastId("");
      setShowOverflowPopover(false);
      setSavedFilterData(null);
      localStorage.removeItem(constants.PERSISTED.filterObj);
      return;
    }
    requestWorklistFilterChange(function () {
      // Get comma-separated filter names for label (same as SearchFilters expects)
      var filterNames = selectedFiltersInPopover.map(function (selectedFilter) {
        var filterItem = savedFilters.find(function (item) {
          return item.id === selectedFilter.id;
        });
        return (filterItem === null || filterItem === void 0 ? void 0 : filterItem.name) || "";
      }).filter(function (name) {
        return name.length > 0;
      }).join(", ");

      // Set filters with selectedFilters array (only values) and label for SearchFilters display
      // Preserve existing filter data (especially search) when applying multiple filters
      var appliedFilters = _objectSpread(_objectSpread({}, filters), {}, {
        // Preserve existing filter properties
        isFilterApplied: true,
        selectedFilters: selectedFiltersInPopover,
        label: filterNames,
        // This will be displayed in SearchFilters "Filtered By:"
        multiSelectLogic: "AND",
        data: _objectSpread(_objectSpread({}, get(filters, ["data"], {})), {}, {
          // Preserve all existing data properties
          search: get(filters, ["data", "search"], "") // Explicitly preserve search
        })
      });
      setFilters(appliedFilters);
      setLastId("");
      setPatientsData(null);
      setShowOverflowPopover(false);
      localStorage.setItem(constants.PERSISTED.filterObj, JSON.stringify(appliedFilters));
      trackEvent(MIXPANEL_EVENTS.LC_FILTER_APPLIED, {
        filterCount: selectedFiltersInPopover.length,
        isMultiSelect: true
      });
    });
  };

  // Handle deselecting all filters in popover (doesn't apply changes)
  var handleDeselectAll = function handleDeselectAll() {
    setSelectedFiltersInPopover([]);
    trackEvent(MIXPANEL_EVENTS.LC_FILTER_CLEARED);
  };

  // Check if selected filters match default filters
  var doSelectedFiltersMatchDefaults = useMemo(function () {
    var defaultFilterIds = get(userInfo, ["settings", "default_filters"], []);

    // Both empty: they match
    if (selectedFiltersInPopover.length === 0 && defaultFilterIds.length === 0) {
      return true;
    }

    // One is empty, the other is not: they don't match
    if (selectedFiltersInPopover.length === 0 || defaultFilterIds.length === 0) {
      return false;
    }

    // Both have filters: check if they match
    var selectedIds = selectedFiltersInPopover.map(function (f) {
      return f.id;
    });
    var selectedIdsSet = new Set(selectedIds.map(function (id) {
      return String(id);
    }));
    var defaultIdsSet = new Set(defaultFilterIds.map(function (id) {
      return String(id);
    }));
    return selectedIdsSet.size === defaultIdsSet.size && Array.from(selectedIdsSet).every(function (id) {
      return defaultIdsSet.has(id);
    });
  }, [selectedFiltersInPopover, userInfo]);

  // Handle making selected filters as default
  var handleMakeDefault = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var filterIds, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setIsSettingDefaultFilters(true);
            _context.p = 1;
            // Allow empty array to set "no filters" as default
            filterIds = selectedFiltersInPopover.map(function (f) {
              return f.id;
            });
            _context.n = 2;
            return setDefaultFilters({
              filter_ids: filterIds
            });
          case 2:
            _context.n = 3;
            return refetchProfile();
          case 3:
            // Apply the selected filters
            if (selectedFiltersInPopover.length === 0) {
              setFilters({
                isFilterApplied: false,
                data: {
                  search: get(filters, ["data", "search"], "")
                }
              });
              setLastId("");
            } else {
              requestWorklistFilterChange(function () {
                var filterNames = selectedFiltersInPopover.map(function (selectedFilter) {
                  var filterItem = savedFilters.find(function (item) {
                    return item.id === selectedFilter.id;
                  });
                  return (filterItem === null || filterItem === void 0 ? void 0 : filterItem.name) || "";
                }).filter(function (name) {
                  return name.length > 0;
                }).join(", ");

                // Set filters with selectedFilters array
                var appliedFilters = _objectSpread(_objectSpread({}, filters), {}, {
                  isFilterApplied: true,
                  selectedFilters: selectedFiltersInPopover,
                  label: filterNames,
                  multiSelectLogic: "AND",
                  data: _objectSpread(_objectSpread({}, get(filters, ["data"], {})), {}, {
                    search: get(filters, ["data", "search"], "")
                  })
                });
                setFilters(appliedFilters);
                setLastId("");
              });
            }

            // Track event for analytics
            trackEvent(MIXPANEL_EVENTS.LC_FILTER_APPLIED, {
              filterCount: filterIds.length,
              isMakeDefault: true,
              filterIds: filterIds
            });
            trackEvent(MIXPANEL_EVENTS.LC_FILTER_SET_DEFAULT, {
              value: filterIds
            });
            Toast.success(t("message.default_saved_filter_updated"));
            // The doSelectedFiltersMatchDefaults memo will recalculate when userInfo changes
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            console.error("Error setting default filters:", _t);
            Toast.error(t("message.default_saved_filter_updated_error"));
          case 5:
            _context.p = 5;
            setIsSettingDefaultFilters(false);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4, 5, 6]]);
    }));
    return function handleMakeDefault() {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("div", {
    ref: mainContainerRef,
    className: "pl-5 flex flex-col flex-1 overflow-hidden bg-white dark:bg-gray-900"
  }, showSearch ? /*#__PURE__*/React.createElement("div", {
    className: "pb-5 relative z-[60]"
  }, /*#__PURE__*/React.createElement(DebounceInput, {
    value: currentSearch,
    onChange: function onChange(val) {
      // setSearch(val);
      requestWorklistFilterChange(function () {
        onChangeSearch(val);
      });
      trackEvent(MIXPANEL_EVENTS.LC_SEARCH_PATIENT_FILTER, {
        search_value: val
      });
    },
    hasClear: true
    //isPrimary
    ,
    placeholder: t("Search or filter patients"),
    className: classNames("rounded-md text-gray-800 dark:text-gray-200 w-full z-40", {
      "border border-teal-500 shadow-md shadow-teal-500/40": currentSearch,
      "border-[1.5px] !border-gray-300 dark:!border-gray-800": !currentSearch
    }),
    LHSIcon: /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faMagnifyingGlass,
      size: "lg",
      className: classNames("w-5 absolute top-1/2 transform-none -translate-y-1/2 left-5 cursor-pointer text-gray-400 dark:text-gray-600", {
        "!text-gray-800 dark:!text-gray-200": filters === null || filters === void 0 ? void 0 : filters.isFilterApplied
      })
    }),
    inputClassName: classNames("!pr-3 !bg-gray-100 dark:!bg-gray-800 sm:dark:!bg-gray-900 placeholder:text-gray-400 focus:!border focus:!outline-none focus:!ring-teal-500/40 focus:!border-teal-500 focus:!shadow-md focus:!shadow-teal-500/40")
  })) : null, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center", {
      relative: !showOverflowFiltersOnHover
    })
  }, canScrollLeft && /*#__PURE__*/React.createElement("div", {
    className: "absolute left-0 z-10 h-full flex items-center bg-gradient-to-r from-black/40 to-transparent pointer-events-none"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: scrollLeft,
    className: "ml-2 p-2.5 bg-transparent rounded-full hover:bg-white/10 transition-colors pointer-events-auto",
    "aria-label": "Scroll left"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    className: "text-white w-6 h-6"
  }))), /*#__PURE__*/React.createElement("div", {
    ref: scrollContainerRef,
    className: classNames("flex gap-4 scrollbar-hide scroll-smooth py-2", {
      "overflow-x-auto": !showOverflowFiltersOnHover,
      "overflow-x-hidden": showOverflowFiltersOnHover
    }),
    style: {
      scrollbarWidth: "none",
      msOverflowStyle: "none"
    }
  }, orderedFilterList === null || orderedFilterList === void 0 ? void 0 : orderedFilterList.map(function (item, index) {
    // Check if filter is selected (handle both single-select and multi-select)
    var isSelected = (filters === null || filters === void 0 ? void 0 : filters.id) === item.id ||
    // Single-select
    (filters === null || filters === void 0 ? void 0 : filters.selectedFilters) && Array.isArray(filters.selectedFilters) && filters.selectedFilters.some(function (f) {
      return f.id === item.id;
    }); // Multi-select

    return /*#__PURE__*/React.createElement("div", {
      ref: function ref(el) {
        if (el) {
          filterRefs.current.set(item.id, el);
        } else {
          filterRefs.current["delete"](item.id);
        }
      },
      className: classNames(showOverflowFiltersOnHover ? "flex items-center gap-3 px-4 py-2 rounded-[8px] cursor-pointer transition-colors whitespace-nowrap group" : "flex relative min-w-[200px] flex-col justify-between border h-auto border-teal-500 dark:border-none bg-white dark:bg-gray-800 whitespace-nowrap py-2 cursor-pointer rounded-lg !px-4", {
        "bg-teal-500 text-white border-teal-500": isSelected && showOverflowFiltersOnHover,
        "bg-gray-100 hover:text-teal-500 dark:bg-gray-800 border dark:border-gray-700": !isSelected && showOverflowFiltersOnHover,
        "!bg-teal-400 dark:!bg-teal-500 !text-gray-100": isSelected && !showOverflowFiltersOnHover
      }),
      key: index,
      onClick: function onClick(e) {
        if (showOverflowFiltersOnHover) {
          // When showOverflowFiltersOnHover is true, open popover and select the clicked filter
          isSettingSelectionProgrammatically.current = true;
          setShowOverflowPopover(true);

          // Initialize selection based on current filters first (same as handleOverflowClick)
          var initialSelection = [];
          if (filters !== null && filters !== void 0 && filters.selectedFilters && Array.isArray(filters.selectedFilters)) {
            initialSelection = filters.selectedFilters;
          } else if (filters !== null && filters !== void 0 && filters.id && filters !== null && filters !== void 0 && filters.isFilterApplied) {
            var singleFilter = savedFilters.find(function (filterItem) {
              return filterItem.id === filters.id;
            });
            if (singleFilter) {
              initialSelection = [{
                id: singleFilter.id,
                values: singleFilter.filter
              }];
            }
          }

          // Toggle the clicked filter
          var isAlreadySelected = initialSelection.some(function (filter) {
            return filter.id === item.id;
          });
          var finalSelection = isAlreadySelected ? initialSelection.filter(function (filter) {
            return filter.id !== item.id;
          }) : [].concat(_toConsumableArray(initialSelection), [{
            id: item.id,
            values: item.filter
          }]);
          setSelectedFiltersInPopover(finalSelection);

          // Reset the flag after a brief delay to allow state to update
          setTimeout(function () {
            isSettingSelectionProgrammatically.current = false;
          }, 0);
        } else if (!isSelected) {
          var _document$getElementB;
          // Original behavior: apply filter directly
          (_document$getElementB = document.getElementById("worklist-container")) === null || _document$getElementB === void 0 || _document$getElementB.scrollTo(0, 0);
          setLastId("");
          handleSingleTagchange(item);
        }
      }
    }, showOverflowFiltersOnHover ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: classNames("font-medium", {
        "text-white": isSelected,
        "text-teal-600 dark:text-teal-400 dark:group-hover:text-white": !isSelected
      })
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: classNames("font-bold", {
        "text-white": isSelected,
        "text-teal-600 dark:text-teal-400 dark:group-hover:text-white": !isSelected
      })
    }, !("count" in item) ? /*#__PURE__*/React.createElement("div", {
      className: "border-solid border-gray-300 dark:border-gray-400 border-2 !border-r-transparent animate-spin inline-block w-4 h-4 rounded-full",
      role: "status"
    }) : (item === null || item === void 0 ? void 0 : item.count) || 0)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: classNames("text-lg sm:text-2xl font-medium text-gray-800 dark:text-gray-200", {
        "!text-gray-100": isSelected
      })
    }, !("count" in item) ? /*#__PURE__*/React.createElement("div", {
      className: "border-solid border-gray-700 dark:border-white border-2 !border-r-transparent animate-spin inline-block w-5 h-5 rounded-full text-blue-600 mr-3",
      role: "status"
    }) : (item === null || item === void 0 ? void 0 : item.count) || 0), /*#__PURE__*/React.createElement("div", {
      title: item.name,
      className: classNames("text-md sm:text-[14px] line-clamp-2 leading-tight text-teal-500 flex text-wrap sm:overflow-hidden dark:text-teal-300", {
        "!text-gray-100": isSelected
      })
    }, item.name), /*#__PURE__*/React.createElement("div", {
      className: "absolute right-2 top-2"
    }, item.description && /*#__PURE__*/React.createElement(Tooltip, {
      content: item.description,
      position: "bottom"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCircleInfo,
      size: "sm",
      className: classNames("p-2 h-5 w-5 rounded-full", {
        "text-gray-400 dark:text-gray-400": isSelected,
        "text-gray-700 dark:text-gray-700": !isSelected
      })
    })))));
  })), canScrollRight && !showOverflowFiltersOnHover && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-0 z-10 h-full flex items-center bg-gradient-to-l from-black/40 to-transparent pointer-events-none"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: scrollRight,
    className: "mr-2 p-2.5 bg-transparent rounded-full hover:bg-white/10 transition-colors pointer-events-auto",
    "aria-label": "Scroll right"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronRight,
    className: "text-white w-6 h-6"
  }))), canScrollRight && showOverflowFiltersOnHover && /*#__PURE__*/React.createElement("div", {
    className: "absolute right-0 z-10 flex items-center justify-end w-24 bg-gradient-to-l from-white dark:from-gray-900 via-white dark:via-gray-900 to-transparent pointer-events-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pointer-events-auto"
  }, /*#__PURE__*/React.createElement("button", {
    ref: overflowButtonRef,
    onClick: handleOverflowClick,
    className: "p-3 bg-transparent rounded-full hover:none transition-colors",
    "aria-label": "Show more filters"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faEllipsisVertical,
    className: "dark:text-white text-gray-800 w-6 h-6"
  })))), showOverflowPopover && showOverflowFiltersOnHover && orderedFilterList.length > 0 && /*#__PURE__*/React.createElement("div", {
    ref: popoverRef,
    className: "absolute z-40 bg-white dark:bg-gray-800 rounded-[8px] shadow-2xl p-4 max-w-[500px] max-h-[400px] w-[min(500px,calc(100vw-32px))] border border-teal-500 dark:border-gray-600 flex flex-col",
    style: {
      top: "".concat(((mainContainerRef === null || mainContainerRef === void 0 || (_mainContainerRef$cur = mainContainerRef.current) === null || _mainContainerRef$cur === void 0 || (_mainContainerRef$cur = _mainContainerRef$cur.getBoundingClientRect()) === null || _mainContainerRef$cur === void 0 ? void 0 : _mainContainerRef$cur.top) || 0) - 50, "px"),
      left: "".concat((scrollContainerRef === null || scrollContainerRef === void 0 || (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 || (_scrollContainerRef$c = _scrollContainerRef$c.getBoundingClientRect()) === null || _scrollContainerRef$c === void 0 ? void 0 : _scrollContainerRef$c.right) || 0, "px")
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between pb-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-md text-gray-800 dark:text-gray-200"
  }, t("saved_filters")), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setShowOverflowPopover(false);
      trackEvent(MIXPANEL_EVENTS.LC_FILTER_OVERFLOW_CLOSED);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "w-5 h-5 text-gray-800 dark:text-gray-200"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-wrap gap-3 overflow-y-auto flex-1 scrollbar-light dark:scrollbar"
  }, orderedFilterList.map(function (item) {
    var isSelectedInPopover = selectedFiltersInPopover.some(function (filter) {
      return filter.id === item.id;
    });
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: classNames("flex items-center gap-3 px-4 py-2 rounded-[8px] cursor-pointer transition-colors whitespace-nowrap", {
        "border-2 border-teal-400": isSelectedInPopover,
        "bg-gray-100 hover:text-teal-500 dark:bg-gray-800 border dark:border-gray-700 group": !isSelectedInPopover
      }),
      onClick: function onClick() {
        // Toggle selection in popover (for multi-select)
        handleToggleFilterSelection(item);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("font-medium text-teal-600 dark:text-teal-400")
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: classNames("font-bold text-teal-600 dark:text-teal-400")
    }, !("count" in item) ? /*#__PURE__*/React.createElement("div", {
      className: "border-solid border-gray-300 dark:border-gray-400 border-2 !border-r-transparent animate-spin inline-block w-4 h-4 rounded-full",
      role: "status"
    }) : (item === null || item === void 0 ? void 0 : item.count) || 0), isSelectedInPopover && /*#__PURE__*/React.createElement("div", {
      className: "h-5 w-5 flex justify-center items-center shadow-md z-10 bg-teal-400 rounded-full"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faXmark,
      size: "xs",
      className: "text-gray-700"
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between pt-4 pb-2 mt-2 border-t border-gray-200 dark:border-gray-700 flex-shrink-0"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleDeselectAll,
    disabled: selectedFiltersInPopover.length === 0,
    className: classNames("uppercase text-md", {
      "text-teal-600 dark:text-gray-300 cursor-pointer hover:text-teal-700 dark:hover:text-white transition-colors": selectedFiltersInPopover.length > 0,
      "text-gray-300 dark:text-gray-600 cursor-not-allowed": selectedFiltersInPopover.length === 0
    })
  }, t("label.deselect_all")), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-3 items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1.5"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: t("text.make_default_saved_filter")
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faInfoCircle,
    size: "sm",
    className: classNames("cursor-pointer", {
      "text-gray-600 dark:text-gray-200": !doSelectedFiltersMatchDefaults,
      "text-gray-300 dark:text-gray-600": doSelectedFiltersMatchDefaults
    })
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleMakeDefault,
    disabled: doSelectedFiltersMatchDefaults || isSettingDefaultFilters,
    className: classNames("uppercase text-md", {
      "text-gray-700 dark:text-gray-200 cursor-pointer hover:text-gray-900 dark:hover:text-white transition-colors": !doSelectedFiltersMatchDefaults && !isSettingDefaultFilters,
      "text-gray-300 dark:text-gray-600 cursor-not-allowed": doSelectedFiltersMatchDefaults || isSettingDefaultFilters
    })
  }, isSettingDefaultFilters ? t("message.saving") || "Saving..." : t("label.make_default"))), /*#__PURE__*/React.createElement("button", {
    onClick: handleMultipleFiltersApply,
    className: "bg-teal-500 hover:bg-teal-600 dark:bg-teal-600 dark:hover:bg-teal-500 text-white uppercase text-md cursor-pointer px-4 py-1.5 rounded-md transition-colors"
  }, t("button.apply")))))), /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center mt-4", {
      hidden: !isLCWorklist
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center", {
      hidden: !isLCWorklist
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faUserCircle,
    size: "sm",
    className: "text-gray-600 dark:text-gray-300"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex ml-2 items-center text-md text-gray-600 dark:text-gray-300"
  }, isCountLoading ? /*#__PURE__*/React.createElement("div", {
    className: "border-solid border-gray-700 dark:border-white border-2 border-r-transparent animate-spin inline-block w-4 h-4 rounded-full text-blue-600 mr-2",
    role: "status"
  }) : patientsCount, /*#__PURE__*/React.createElement("div", {
    className: "ml-2"
  }, t("patients_key"))))));
};
export default LCAccessFilters;